import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import AnimatedButton from "@components/WebsiteRevamp/AnimatedButton/AnimatedButton"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	BackendButton,
	HeroModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import Image from "next/image"
import React, {useRef} from "react"

import styles from "./ProductHero.module.scss"

interface ProductHeroProps {
	data: HeroModuleType
	className?: string
	textColor?: "black" | "white"
	titleStyle?: string
	theme?: "oneDefault" | "studio" | "oneHome"
}

const ProductHero: React.FC<ProductHeroProps> = ({
	data,
	className,
	textColor = "black",
	titleStyle = "",
	theme,
}) => {
	const ref = useRef<SVGSVGElement | null>(null)

	const colors = [
		"linear-gradient(348deg, #BBD2FF 7.81%, #F1F5FF 89.34%)",
		"linear-gradient(172deg, #4180FF 10.27%, #175EEB 74.9%)",
		"linear-gradient(0deg, #BE01BD 19.34%, #F045EF 82.28%)",
	]

	let backgroundColor = colors[0]

	if (theme === "oneDefault") {
		backgroundColor = colors[1]
	} else if (theme === "studio") {
		backgroundColor = colors[2]
	}

	return (
		<ContainerWrapper>
			<div
				style={{
					// overflow: "hidden",
					lineHeight: 0,
					position: "relative",
				}}>
				<div
					className={`${styles.mainBackground} ${className}`}
					style={{
						background: backgroundColor,
					}}>
					<div
						style={{
							position: "relative",
						}}>
						<div className={styles.contentBox}>
							<div
								className={styles.contentWrapper}
								style={{color: textColor}}>
								<div className={styles.titleContainer}>
									<div className={styles.titleBox}>
										<Typography
											as={"h1"}
											className={`${styles.title} ${titleStyle}`}
											content={data.title}
											fontWeight={200}
											size={Size.XXL}
											variant={Variant.Title}
											contrast
											noPadding
											style={{
												lineHeight: "3.75rem",
											}}
										/>
										{data?.buttons &&
											data?.buttons?.length > 0 && (
												<>
													<div
														className={
															styles.ButtonContainer
														}>
														{data.buttons.map(
															(
																btn: BackendButton,
																index: number,
															) => (
																<AnimatedButton
																	key={index}
																	text={
																		btn.text
																	}
																	href={
																		btn.link
																	}
																	popup={{
																		data,
																		type: "asset",
																	}}
																	// @ts-expect-error
																	variant={
																		btn.buttonType
																	}
																	disablePaddingHorizontalClass={
																		btn.buttonType ===
																		"text"
																			? styles.disablePaddingHorizontalClass
																			: ""
																	}
																	theme={
																		theme
																	}
																	contrast={
																		"dark"
																	}
																/>
															),
														)}
													</div>
												</>
											)}
									</div>
								</div>
							</div>
						</div>
						<Image
							alt={data.desktopAsset?.alt ?? ""}
							className={styles.image}
							height={data.desktopAsset?.height || 1024}
							src={data.desktopAsset?.src ?? ""}
							style={{
								bottom: "16px",
							}}
							width={data.desktopAsset?.width || 1920}
						/>
						<Image
							alt={""}
							className={styles.imageShine}
							height={data.rightSideAsset?.height ?? 100}
							src={data.rightSideAsset?.src ?? ""}
							style={{
								bottom: "-15%",
							}}
							width={data.rightSideAsset?.width ?? 100}
						/>
						<div
							style={{
								position: "relative",
								height: "105%",
								top: "-1px",
							}}
							className={styles.beforeBottomWhite}>
							<svg
								ref={ref}
								preserveAspectRatio={"xMinYMin meet"}
								style={{
									position: "relative",
									zIndex: 2,
									top: "0",
									left: "-2px",
									height: "calc(100% + 4px)",
									width: "calc(100% + 4px)",
								}}
								viewBox={"0 0 1943 202"}
								xmlns={"http://www.w3.org/2000/svg"}>
								<path
									d={
										"M815.5 0H0.5V202H1946V0H1811.5C1680 0 1559.5 226.5 1285.5 108.5C1077 18.708 995 0 815.5 0Z"
									}
									fill={"white"}
									xmlns={"http://www.w3.org/2000/svg"}
								/>
							</svg>
						</div>
					</div>
				</div>
			</div>
		</ContainerWrapper>
	)
}
export default ProductHero
